import { Trans } from '@lingui/macro';
import { Image, FileText, Mic, Video, Filter } from 'lucide-react';
import { useState } from 'react';
// useHistory removed
import { useAppUIContext } from '../../context/AppUIContext';
import { FilterType } from '../../models/local/Types';
import { Popover, PopoverContent, PopoverTrigger } from '../../components/ui/popover';
import { Button, ButtonProps } from '../../components/ui/button';
import { cn } from '../../lib/utils';

interface FilterPopoverProps {
  roomId: string;
  className?: string;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
}

const FilterPopover: React.FC<FilterPopoverProps> = ({
  roomId,
  className,
  variant = "icon-box",
  size
}) => {
  const [open, setOpen] = useState(false);
  const { filter, setFilter } = useAppUIContext();
  // unused history removed


  const changeType = (t: FilterType) => {
    setOpen(false);
    setTimeout(() => {
      setFilter(t);
    }, 40);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant={variant} size={size} className={className}>
          <Filter className="h-4 w-4 text-orange-500" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-0" align="end">
        <div className="flex flex-col">
          {/* Filter Header */}
          <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase">
            <Trans>Filter messages</Trans>
          </div>

          {/* Filter Options */}
          <button
            onClick={() => changeType('photos')}
            className={cn(
              "flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors text-left",
              filter === 'photos' && "bg-orange-50 text-orange-600"
            )}
          >
            <Image className="h-5 w-5" />
            <span className="text-sm"><Trans>Photos</Trans></span>
          </button>
          <button
            onClick={() => changeType('docs')}
            className={cn(
              "flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors text-left",
              filter === 'docs' && "bg-orange-50 text-orange-600"
            )}
          >
            <FileText className="h-5 w-5" />
            <span className="text-sm"><Trans>Docs</Trans></span>
          </button>
          <button
            onClick={() => changeType('voice')}
            className={cn(
              "flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors text-left",
              filter === 'voice' && "bg-orange-50 text-orange-600"
            )}
          >
            <Mic className="h-5 w-5" />
            <span className="text-sm"><Trans>Voice</Trans></span>
          </button>
          <button
            onClick={() => changeType('video')}
            className={cn(
              "flex items-center gap-3 px-4 py-3 hover:bg-gray-50 transition-colors text-left",
              filter === 'video' && "bg-orange-50 text-orange-600"
            )}
          >
            <Video className="h-5 w-5" />
            <span className="text-sm"><Trans>Screen Recording</Trans></span>
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default FilterPopover;

